<template>
  <div class="Information">
      <div class="mine_title">
        My Referrer
      </div>
      <!-- 内容 -->
      <div class="info" v-if="info.name">
        <p class="inforow">
          <span class="inforow-l">Full name</span>
          <span class="inforow-r">{{ info.name }}</span>
        </p>

        <!-- <p class="inforow">
          <span class="inforow-l">Phone Number</span>
          <span class="inforow-r">{{ info.mobile }}</span>
        </p> -->

        <p class="inforow">
          <span class="inforow-l">Email</span>
          <span class="inforow-r">{{ info.email ? info.email : '-' }}</span>
        </p>
      </div>
      <!-- 无内容时 -->
      <div class="add-inviter" @click="add" v-else>
        <i class="el-icon-circle-plus-outline"></i>
        Add Referrer
      </div>
      <!-- 弹框 -->
      <el-dialog
        :visible.sync="showDetailFlag"
        title="Add Referrer"
        width="30%"
        custom-class="editdetailDialog"
        @close="closedialogEvent"
      >
        <div>
          <el-form :model="ruleForm" status-icon label-position="left" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
            <el-form-item label="Referral code" prop="">
              <el-input v-model="ruleForm.code" placeholder="Please enter your referral code"></el-input>
            </el-form-item>            
            <span class="dialog-footer">
                <el-button class="cancelbtn1" @click="edithandleClose('ruleForm')">Cancel</el-button>
                <el-button class="Confirmbtn1" @click="tohandleEditdialog('ruleForm')">Confirm</el-button>
              </span>
          </el-form>
        </div>
      </el-dialog>
  </div>
</template>
<script>
export default {
  components: {
      
  },
  data() {
    return {
      //菜单列表
      info:{
        Full: '+226 1008****',
        Email: 'Canada@Alberta.cn',
      },
      showDetailFlag: false,
      ruleForm:{
        code:''
      },
      rules:{

      }
    };
  },
  mounted(){
    this.getInfo()
  },
  methods:{
    getInfo(){
      this.$http.get('/tutor/api/myInviter').then((res) => {
          if (res.data.code == 200) {
            this.info = res.data.data;
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        })
        .catch((error) => {
          console.log(error); // 请求失败返回的数据
        });
    },
    closedialogEvent(){

    },
    edithandleClose(){
      this.showDetailFlag = false
    },
    tohandleEditdialog(){
      this.$http.post('/tutor/api/myInviterAdd',{
        invite_code:this.ruleForm.code
      }).then((res) => {
          if (res.data.code == 200) {
            // this.info = res.data.data;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getInfo()
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        })
        .catch((error) => {
          console.log(error); // 请求失败返回的数据
        });
      this.showDetailFlag = false
    },
    add(){
      this.showDetailFlag = true
    }
  }
};
</script>
<style lang="less" scoped>
.Information{
  background: #fff;
  padding: 0 24px;
  position: relative;
  .mine_title{
      font-family: Roboto;
      font-size: 24px;
      font-weight: 600;
      font-feature-settings: "kern" on;
  }
  .info{
    margin-top: 10px;
    .inforow{
      line-height: 4;
      font-family: Roboto;
      font-size: 16px;
      font-weight: normal;
      .inforow-l{
        color: #6B7280;
        width: 386px;
        display: inline-block;
      }
    }
  }
  .add-inviter{
    color: #ff904d;
    position: absolute;
    right: 20px;
    top: 10px;
    cursor: pointer;
  }
  /deep/ .editdetailDialog {
      background: #fffae5;
      .el-dialog__title {
        font-size: 22px;
      }
      .el-dialog__header{
        padding: 24px;
      }
      .el-dialog__body{
        padding: 0 24px 24px 24px !important;
        .codebox{
          display: flex;
          flex-direction: row;
          .codeInput{
            display: inline-block;
          }
          .codebtn{
            background-color: #ff904D;
            margin-left: 20px;
            display: inline-block;
            color: #fff;
          }
        }
      }
      .dialog-footer{
        width: 100%;
      }
      .cancelbtn1{
        width: 48%;
        background: transparent;
        color: #666;
        border: 1px solid #ccc;
      }
      .Confirmbtn1 {
        width: 48%;
        height: 45px;
        margin-left: 2%;
        color: #fff;
        background: #ff904d;
        border: none;
        margin-top: 10px;
        margin-bottom: 20px;
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/views/childrens/Myinviter.vue